import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Login from "./pages/auth/Login";
import Profile from "./pages/auth/Profile";
import StatusStudent from "./pages/account/StatusStudent";
import SentryDiagnostic from "./pages/diagnostics/SentryDiagnostic";
import "./App.scss";
import ProtectedRoute from "./services/ProtectedRoute";

import { getConfig } from "./services/Config.service";
import ConfigContext, { initialConfig } from "./context/Config";

function App() {
  const [config, setConfig] = useState({ loading: true, data: initialConfig, error: false });
  const [attempt, setAttempt] = useState(0);
  const { loading, data, error } = config;

  useEffect(() => {
    let active = true;
    async function getConfigAsync() {
      try {
        const result = await getConfig();
        if (result.error || !result.data) {
          throw new Error("Unable to load application configuration");
        }
        if (active) {
          setConfig({ loading: false, data: result.data, error: false });
        }
      } catch {
        if (active) {
          setConfig({ loading: false, data: initialConfig, error: true });
        }
      }
    }
    getConfigAsync();
    return () => { active = false; };
  }, [attempt]);

  if (loading) {
    return <div className="App"><p role="status">Cargando aplicación</p></div>;
  }

  if (error) {
    return (
      <div className="App">
        <p role="alert">No se pudo cargar la configuración. Revisa tu conexión e inténtalo de nuevo.</p>
        <button type="button" onClick={() => {
          setConfig({ loading: true, data: initialConfig, error: false });
          setAttempt(current => current + 1);
        }}>Reintentar</button>
      </div>
    );
  }

  return (
    <div className="App">
      {data.error && <p>'Error getting config from server'</p>}
      <ConfigContext.Provider value={data}>
        <Header></Header>
        <Container fluid className="p-0 mt-5">
          <Router basename={process.env.PUBLIC_URL}>
            <Switch>
              <ProtectedRoute exact path="/sentry-diagnostic">
                <SentryDiagnostic></SentryDiagnostic>
              </ProtectedRoute>
              <ProtectedRoute path="/accountstatus">
                <StatusStudent></StatusStudent>
              </ProtectedRoute>
              <ProtectedRoute path="/profile">
                <Profile></Profile>
              </ProtectedRoute>
              <Route path="/login">
                <Login></Login>
              </Route>
              <Route path="/">
                <Login></Login>
              </Route>
            </Switch>
          </Router>
        </Container>
        <Footer></Footer>
      </ConfigContext.Provider>
    </div>
  );
}

export default App;
